export enum RequestListType {
  ActiveRequests = 0,
  AllRequests = 1,
}
